import React from 'react';
import { useMutation } from '@tanstack/react-query';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetcher } from '@dashboard/services/request';

import DialogOld from '@dashboard/components/DialogOld';
import Form from '@dashboard/components/Formik/Form';

const CreateCheckoutFromTemplateDialog = ({
  isOpen,
  onClose,
  templateId,
  pageId,
  productTitle,
  pageTitle,
  type,
  title,
  onCreate = () => {},
}) => {
  const { sellerId, token } = useAuth();

  const createFromTemplateMutation = useMutation({
    mutationFn: values =>
      fetcher(
        `/sellers/${sellerId}/pages/from-template?templateId=${templateId}&pageId=${pageId}`,
        token,
        {
          method: 'POST',
          body: JSON.stringify(values),
        },
      ),
    onSuccess: onCreate,
  });

  return (
    <DialogOld isOpen={isOpen} onClose={onClose} title={title} size="lg">
      <div className="h-full flex-1 flex flex-col mt-2">
        <Form
          showState={false}
          initialValues={{
            ...(type === 'checkout' && {
              name: `${productTitle}`,
            }),
            ...(type === 'form' && {
              name: `${pageTitle}`,
            }),
          }}
          onSubmit={async (values, actions) => {
            try {
              const data = await createFromTemplateMutation.mutateAsync({
                name: values.name,
              });

              actions.resetForm();

              return {
                data: {
                  name: data.name,
                },
              };
            } catch (err) {
              return {
                error: err.message,
              };
            }
          }}
          fields={[
            ...((type === 'checkout' && [
              {
                name: 'name',
                label: 'Product title',
                type: 'text',
                placeholder: 'Product title',
                required: true,
              },
            ]) ||
              []),

            ...((type === 'form' && [
              {
                name: 'name',
                label: 'Form title',
                type: 'text',
                placeholder: 'Form title',
                required: true,
              },
            ]) ||
              []),
          ]}
          submitButton={{
            label: 'Continue',
            size: 'full',
          }}
        />
      </div>
    </DialogOld>
  );
};

export default CreateCheckoutFromTemplateDialog;
